import { ApiGetCompaniesResponse } from '../../../module/api/api/isp-web/companies/api-get-companies.response';
import {
  ApiGetCompanyMembersResponse,
} from '../../../module/api/api/company-web/members/api-get-company-members.response';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { apiCompany, apiIsp, ApiManager } from '../../../managers/api-manager';
import { breadcrumbParts } from '../../../models/breadcrumb-parts';
import { CompanyData } from '../../../models/company-data';
import { PageComponentDefaultProps } from '../../../models/page-component-default-props';
import { BreadcrumbList } from '../../ui/breadcrumb-list/breadcrumb-list';
import { Button } from '../../ui/button/button';
import { Header } from '../../ui/header/header';
import { LabeledForm } from '../../ui/input/labeled-form';
import { SideBar } from '../../ui/sidebar/sidebar';
import { SelectInfoData, ChangeLabelData } from '../../ui/select/react-select';
import { useDidMount } from '../../../hooks/life-cycle';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import './operation-log.scss';
import { cloneDeep } from 'lodash';
import { SingleValue } from 'react-select';
import { Input } from '../../ui/input/input';
import { DateFormatter, ZeroPadding } from '../../../utilities';
import { ValidationFactory } from '../../../managers/validation/validation-factory';
import { CheckAllValid, Validation } from '../../../managers/validation/validation';
import deleteIcon from '../../../assets/images/common/icon_delete.svg';
import { useLogProduct } from './hooks/use-log-product';
import { push } from 'connected-react-router';
import { RoutingPath } from '../../../routes/routing-path';
import { ApiGetIspUsersResponse } from '../../../module/api/api/isp-web/users/api-get-isp-users.response';
import { IspUserData } from '../../../models/isp-user-data';
import { IspLogOperation } from '../../../models/logs/isp-log-operation';

export type SelectData = {
  key: string,
  label: string,
};

const ispBreadcrumbList = [
  breadcrumbParts.isp.home,
  breadcrumbParts.isp.ispDeleteDataLog,
];

const companyBreadcrumbList = [
  breadcrumbParts.company.home,
  breadcrumbParts.company.ispLog,
];

// バリデーション用意
const validations: { [key: string]: Validation } = {
  checkAfterTodayStartDate: ValidationFactory('require'),
  checkAfterTodayEndDate: ValidationFactory('require'),
  checkStartThanPastDate: ValidationFactory('require'),
};

export const DeleteDataOperationLog = (props: PageComponentDefaultProps) => {
  const { apiManger } = props;
  const breadcrumbList = apiManger.type === 'isp' ? ispBreadcrumbList : companyBreadcrumbList;
  const { companyUserInfo } = useAppSelector((state) => state.loginCompanyUserInfo);

  /* Hooks */
  const dispatch = useAppDispatch();
  /* State */
  /* ---- 検索 ---- */
  /* プロダクト選択 */
  /* 選択企業　*/
  /* 日付　*/
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  /* ログ開始日 */
  const [_startLogDate, setStartLogDate] = useState<Date | null>(null);

  const startLogDate = useMemo(() => {
    if (apiManger.type === 'company') return _startLogDate;
    return null;
  }, [_startLogDate, apiManger]);
  /* -------------- */

  /* 各種リスト */
  /* DLボタン制御 */
  const [validFlag, setValidFlag] = useState(false);
  // バリデーションのトータルチェック
  const [checkValidation, setCheckValidation] = useState(CheckAllValid(validations));
  /* Memo */
  /* Ref */
  const startRef = useRef<HTMLInputElement>(null);
  const endRef = useRef<HTMLInputElement>(null);

  // バリデーション用登録時の日付
  const now = useMemo(() => {
    return new Date();
  }, []);
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();

  const todayValid = useMemo(() => {
    return String(year) + ZeroPadding(month, 2) + ZeroPadding(day, 2);
  }, [year, month, day]);

  // - ユーザー選択 -

  // - DLボタン -
  const onClickDL = useCallback(() => {
    if (apiManger.type === 'isp') {
      IspLogOperation('deleteDataLogDl');
      apiIsp.deleteCompany().downloadLog({
        extract_date_start: startDate ? DateFormatter.date2str(new Date(startDate), 'YYYYMMDD', '-') : '',
        extract_date_end: endDate ? DateFormatter.date2str(new Date(endDate), 'YYYYMMDD', '-') : DateFormatter.date2str(new Date(), 'YYYYMMDD', '-'),
      }).then((res) => {
        const a = document.createElement('a');
        const url = URL.createObjectURL(res);
        a.download = `データ削除ログ.csv`;
        a.href = url;
        a.click();
        URL.revokeObjectURL(url);
        a.remove();
      }).catch((e) => {
        ApiManager.errorFunc(e);
      });
    } else {
      return;
    }
  }, [startDate, endDate, apiManger]);

  const sortInitialize = useCallback(() => {
    setStartDate(null);
    setEndDate(null);
  }, [apiManger.type]);

  /* 検索条件削除 */
  const onClickSortDelete = useCallback(() => {
    sortInitialize();
  }, [sortInitialize]);

  // - 指定開始日 -
  const changeStartDate = useCallback((v) => {
    setStartDate(v);
    window.setTimeout(() => {
      if (endRef.current) {
        endRef.current.focus();
        endRef.current.blur();
      }
    }, 0)
  }, [endRef]);
  // - 指定終了日 -
  const changeEndDate = useCallback((v) => {
    setEndDate(v);
    window.setTimeout(() => {
      if (startRef.current) {
        startRef.current.focus();
        startRef.current.blur();
      }
    }, 0)
  }, [startRef]);

  /* Effect */
  // - 企業選択 一覧取得 -
  useDidMount(() => {
    if (apiManger.type === 'company') {
      dispatch(push(RoutingPath.companyStatus));
      return;
    }
    
    validations['checkAfterTodayStartDate'] = new Validation({
      test: (v: string) =>
        v === '' || Number(v.replace(/-/g, '')) <= Number(todayValid),
      errorMessages: ['今日以降の設定はできません'],
    });
    validations['checkAfterTodayEndDate'] = new Validation({
      test: (v: string) =>
        v === '' || Number(v.replace(/-/g, '')) <= Number(todayValid),
      errorMessages: ['今日以降の設定はできません'],
    });
    setValidFlag(true);
  });

  useEffect(() => {
    if (!startRef.current || !endRef.current) return;
    validations['checkStartThanPastDate'] = new Validation({
      test: (v: string) =>
        v === '' || Number(startRef.current!.value.replace(/-/g, '')) <= Number(v.replace(/-/g, '')),
      errorMessages: ['指定開始日より過去日の設定はできません'],
    });
  }, [validFlag]);

  useEffect(() => {
    setCheckValidation(CheckAllValid(validations));
  }, [startDate, endDate]);
  const isDisabled = useMemo(() => {
    return !!(
      (!startDate && !endDate)
      || (startDate && endDate && endDate.getTime() < startDate.getTime()));
  }, [
    startDate,
    endDate,
  ]);
  return (
    <div
      id="App"
      className="operation_log"
    >
      <SideBar
        currentPage="delete-data-log-Management"
        apiManger={apiManger.type}
      />
      <div className="main_cnt">
        <Header apiManger={apiManger.type} />
        <div className="inner">
          <BreadcrumbList breadcrumbList={breadcrumbList} />
          <div className="inner">
            <section className="">
              <header>
                <h2>データ削除ログ</h2>
              </header>
              <div className="operation_log__body__wrap edit_wrap">
                <div className="operation_log__body">
                  <div className="operation_log__body__row row_forms">
                    <div className="operation_log__body__row">

                  </div>
                    <Button
                      className="delete_btn"
                      label=""
                      onClick={onClickSortDelete}
                      color="quaternary"
                      icon={<img src={deleteIcon} alt="" />}
                      size="large"
                      title="入力内容をリセット"
                    />
                  </div>
                  <div className="operation_log__body__row row_period edit_wrap">
                    <div className="period_form__wrap date_box">
                      <div className="period_form">
                        <LabeledForm
                          label="指定開始日"
                          formEle={
                            <Input
                              type="date"
                              onChange={(e) => {
                                changeStartDate(e.target.value ? new Date(e.target.value) : null)
                              }}
                              onClickClearDate={() => changeStartDate(null)}
                              value={startDate ? DateFormatter.date2str(startDate, 'YYYYMMDD', '-') : ''}
                              max={DateFormatter.date2str(new Date(), 'YYYYMMDD', '-')}
                              min={startLogDate ? DateFormatter.date2str(startLogDate, 'YYYYMMDD', '-') : undefined}
                              validations={[validations.checkAfterTodayStartDate]}
                              ref={startRef}
                            />
                          }
                        />
                        <div className="period_form__tilde" />
                        <LabeledForm
                          label="指定終了日"
                          formEle={
                            <Input
                              type="date"
                              onChange={(e) => {
                                changeEndDate(e.target.value ? new Date(e.target.value) : null)
                              }}
                              value={endDate ? DateFormatter.date2str(endDate, 'YYYYMMDD', '-') : ''}
                              onClickClearDate={() => changeEndDate(null)}
                              max={DateFormatter.date2str(new Date(), 'YYYYMMDD', '-')}
                              min={startLogDate ? DateFormatter.date2str(startLogDate, 'YYYYMMDD', '-') : undefined}
                              validations={[validations.checkAfterTodayEndDate, validations.checkStartThanPastDate]}
                              ref={endRef}
                            />
                          }
                        />
                      </div>
                      <div
                        className="period_form__announce">
                        ※開始日または終了日のどちらか一方は必ず設定してください
                          </div>
                    </div>
                    <Button
                      label="DL"
                      onClick={onClickDL}
                      disabled={isDisabled}
                    />
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};